<template>
    <v-container class="text-center">
        <v-row class="mb-6">
            <v-col md="12">
                <h1>Please Enter Your Name</h1>
            </v-col>
        </v-row>
        <v-row class="mb-6">
            <v-col md="2" offset-md="5">
                <v-text-field
                    v-model='name'
                    label='Name'
                    :rules="nameRestrictions">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row class="mb-6" >
            <v-col md="12" >
                <v-btn elevation='12' x-large rounded v-on:click='enrole'>JOIN</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'EntryPage',
    data() {
        return {
            name: '',
            nameRestrictions: [
                value => !!value || 'Please enter a name.',
                value => (value && value.length >= 3) || 'Min 3 characters',
                value => (value && value.length <= 12) || 'Max 12 characters',
            ]
        }
    },
    methods: {
        ...mapActions(['addContestant']),
        enrole() {
            if (this.name && this.name.length >= 3 && this.name.length <= 12) {
                this.addContestant(this.name);
            }
        }
    }
}
</script>
